/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationsPathParameters } from 'api/actions/get-reservations/get-reservations-path-parameters';
import { GetReservationsResponse } from 'api/actions/get-reservations/get-reservations-response';

type GetReservationsQueryParameters = Record<string, any>;

/**
 * The path of the GetReservations action.
 */
export const getReservationsActionPath = new SweetPath<keyof GetReservationsPathParameters>('/reservations', {
  path: '{param}',
});

/**
 * Creates a contextualized GetReservations actions.
 */
export default function createGetReservationsAction(axios: AxiosInstance) {
  return function getReservationsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetReservationsQueryParameters } = {}) {
    const path = getReservationsActionPath.original;

    return axios.get<GetReservationsResponse, GetReservationsResponse>(path, { params: query, headers });
  };
}
